import styled from 'styled-components';

export const Container = styled.label`
  display: flex;
  padding: 7px 14px;
  cursor: pointer;
`;

export const Label = styled.div`
  margin-left: 4px;
  min-width: 0;
`;
